import React, { type FC } from "react";
import SidePanel from "../../../../../../../shared-components/css-modules/toyota/organisms/SidePanel";
import commonPackStyles from "../Pack.module.scss";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";
import Collapse from "../../../../../../../shared-components/css-modules/toyota/molecules/Collapse";
import { getCarDBAssetSrcSet } from "../../../../../../../../shared-logic/utils/imageUtils";
import Text from "../../../../../../../shared-components/css-modules/toyota/atoms/Text";
import type { useAphPackType } from "../../../../../../hooks/useAphPack";
import { useCarConfigDispatch, useCarConfigSelector } from "../../../../../../redux/store";
import Button from "../../../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./PacksAndExtras.module.scss";
import { trackOptionsBasketPackAdd, trackOptionsBasketPackRemove } from "../../../../../../utils/tracking";
import type { PackType } from "../../../../../../../../../common-deprecated/types/CommonTypes";
import { setPackAddedByExtra } from "../../../../../../redux/slices/CarConfigNavigationSlice";

type PackSidePanelProps = {
    isSidePanelOpen: boolean;
    setIsSidePanelOpen: (isOpen: boolean) => void;
    packProps: useAphPackType;
    active: boolean;
    pack: PackType;
};

export const PackSidePanel: FC<PackSidePanelProps> = (props) => {
    const dispatch = useCarConfigDispatch();
    const { isSidePanelOpen, setIsSidePanelOpen, packProps, active, pack } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const { actions } = packProps;
    const { selectPack, deselectPack, displayNotifications } = actions;

    const handleClickPack = (): void => {
        if (packProps.packContent.availability.enabled) {
            if (active) {
                trackOptionsBasketPackRemove();
                deselectPack();
            } else {
                trackOptionsBasketPackAdd();
                selectPack();
                displayNotifications();
                dispatch(setPackAddedByExtra(pack));
            }

            setIsSidePanelOpen(false);
        }
    };

    return (
        <SidePanel
            open={isSidePanelOpen}
            onRequestClose={() => {
                setIsSidePanelOpen(false);
            }}
        >
            <header className={commonPackStyles["panel-header"]}>
                <CarConfigLabel
                    label="carConfigPacksSidepanelTitle"
                    params={{ title: pack.name, count: packProps.packContent.totalPackContent }}
                    useHTML
                />
            </header>
            <div className={commonPackStyles["panel-content"]}>
                {packProps.packContent.renderedEquipment.map((item) => (
                    <div key={item.id} className={commonPackStyles["panel-item"]}>
                        <Collapse summary={item.name} className={commonPackStyles.details}>
                            <figure className={commonPackStyles["panel-item-image"]}>
                                <img
                                    {...getCarDBAssetSrcSet(
                                        commonSettings,
                                        [
                                            { width: 380, height: 380 },
                                            { width: 450, height: 450 },
                                            { width: 504, height: 504 },
                                            { width: 800, height: 800 },
                                            { width: 1000, height: 1000 },
                                        ],
                                        item.image,
                                    )}
                                    width="380"
                                    height="380"
                                    sizes="(max-width: 1199px) 100vw, 33vw"
                                    alt=""
                                    role="presentation"
                                />
                            </figure>
                            <Text variant="apheleia-body" spacing="spacing-0">
                                {item.description}
                            </Text>
                        </Collapse>
                    </div>
                ))}
            </div>

            <Button variant={active ? "btn-secondary" : "btn-default"} onClick={handleClickPack} className={styles.add}>
                {active ? (
                    <CarConfigLabel label="carConfigRemovePackFromBasket" />
                ) : (
                    <CarConfigLabel label="carConfigAddPackToBasket" />
                )}
            </Button>
        </SidePanel>
    );
};
